import { create } from "zustand"

const useFetchTicketsHoldOrders = create((set) => ({
  ticketsOrders: [],
  ticketsHoldOrderCount: 0,
  loading: true,
  setTicketsHoldOrders: (orders) =>
    set({ ticketsOrders: orders, ticketsHoldOrderCount: orders.length, loading: false }),
  setTicketsHoldOrdersLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useFetchTicketsHoldOrders
